export const numberToWords = (number) => {
  if (!number || isNaN(number) || number === 0) return "Không đồng";
  const strNumber = Math.round(number).toString();
  const chuSo = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
  const tien = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];

  const row = [];
  for (let i = strNumber.length; i > 0; i -= 3) {
    row.push(strNumber.substring(Math.max(i - 3, 0), i));
  }

  const docHangChuc = (so, daydu) => {
    let chuoi = "";
    const chuc = Math.floor(so / 10);
    const donvi = so % 10;
    if (chuc > 1) {
      chuoi = ` ${chuSo[chuc]} mươi`;
      if (donvi === 1) chuoi += " mốt";
    } else if (chuc === 1) {
      chuoi = " mười";
      if (donvi === 1) chuoi += " một";
    } else if (daydu && donvi > 0) {
      chuoi = " linh";
    }
    if (donvi === 5 && chuc >= 1) chuoi += " lăm";
    else if (donvi > 1 || (donvi === 1 && chuc === 0)) chuoi += ` ${chuSo[donvi]}`;
    return chuoi;
  };

  const docKhoi = (so, daydu) => {
    const tram = Math.floor(so / 100);
    const soDu = so % 100;
    if (daydu || tram > 0) {
      return ` ${chuSo[tram]} trăm${docHangChuc(soDu, true)}`;
    }
    return docHangChuc(soDu, false);
  };

  let ketQua = "";
  const viTri = row.length - 1;
  for (let i = viTri; i >= 0; i -= 1) {
    const soNhom = parseInt(row[i], 10);
    if (soNhom > 0) {
      ketQua += `${docKhoi(soNhom, i !== viTri)} ${tien[i]}`;
    }
  }

  const normalized = ketQua.trim();
  return `${normalized.charAt(0).toUpperCase() + normalized.slice(1)} đồng chẵn`;
};

const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

const splitDate = (text = "") => {
  const [day = "", month = "", year = ""] = String(text).split("/");
  return {
    day: day.replace(/\D/g, "").padStart(2, "0"),
    month: month.replace(/\D/g, "").padStart(2, "0"),
    year: year.replace(/\D/g, ""),
  };
};

export const getPrintTemplate = ({ headerInfo, rows, totalAmount, totalAmountInWords }) => {
  const reportDate = splitDate(headerInfo.reportDate || "");

  const bodyRows = (rows || [])
    .map(
      (row) => `
      <tr>
        <td class="cell center">${escapeHtml(row.serialNumber)}</td>
        <td class="cell center">${escapeHtml(row.voucherNumber || "")}</td>
        <td class="cell center">${escapeHtml(row.voucherDate || "")}</td>
        <td class="cell">${escapeHtml(row.expenseContent || "")}</td>
        <td class="cell right">${fmtMoney(row.amount || 0)}</td>
      </tr>`
    )
    .join("");

  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Bảng kê chi tiền</title>
      <style>
        @media print { @page { margin: 10mm 8mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 15px; color:#000; margin: 0; padding: 12px; }
        .header { display:flex; justify-content:space-between; align-items:flex-start; }
        .left { line-height:1.45; }
        .right { text-align:right; line-height:1.45; }
        .title { text-align:center; margin-top:14px; font-size:28px; font-weight:700; text-transform:uppercase; }
        .subtitle { text-align:center; margin-top:6px; font-style:italic; }
        .line { margin-top:6px; }
        table { width:100%; border-collapse: collapse; margin-top: 10px; }
        .cell { border: 1px solid #000; padding: 5px 6px; font-size: 15px; }
        .center { text-align: center; }
        .right { text-align: right; }
        .bold { font-weight: 700; }
        .signatures { margin-top: 24px; display:flex; justify-content:space-between; text-align:center; }
        .sign-col { width: 30%; }
        .sign-spacer { height: 18px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="left">
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit || "")}</div>
          <div><b>Bộ phận:</b> ${escapeHtml(headerInfo.department || "")}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số 09 - TT</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">BẢNG KÊ CHI TIỀN</div>
      <div class="subtitle">
        Ngày ${escapeHtml(reportDate.day || "...")} tháng ${escapeHtml(reportDate.month || "...")} năm ${escapeHtml(reportDate.year || "....")}
      </div>

      <div class="line">Họ và tên người chi: ${escapeHtml(headerInfo.payerName || "")}</div>
      <div class="line">Bộ phận (hoặc địa chỉ): ${escapeHtml(headerInfo.payerDepartmentAddress || "")}</div>
      <div class="line">Chi cho công việc: ${escapeHtml(headerInfo.workDescription || "")}</div>

      <table>
        <thead>
          <tr>
            <th class="cell center" rowspan="2" style="width:10%">STT</th>
            <th class="cell center" colspan="2" style="width:34%">Chứng từ</th>
            <th class="cell center" rowspan="2" style="width:36%">Nội dung chi</th>
            <th class="cell center" rowspan="2" style="width:20%">Số tiền</th>
          </tr>
          <tr>
            <th class="cell center">Số hiệu</th>
            <th class="cell center">Ngày, tháng</th>
          </tr>
          <tr>
            <th class="cell center">A</th>
            <th class="cell center">B</th>
            <th class="cell center">C</th>
            <th class="cell center">D</th>
            <th class="cell center">1</th>
          </tr>
        </thead>
        <tbody>
          ${bodyRows}
          <tr>
            <td class="cell"></td>
            <td class="cell"></td>
            <td class="cell"></td>
            <td class="cell center bold">Cộng</td>
            <td class="cell right bold">${fmtMoney(totalAmount || 0)}</td>
          </tr>
        </tbody>
      </table>

      <div class="line">Số tiền bằng chữ: <b>${escapeHtml(totalAmountInWords || "")}</b></div>
      <div class="line">(Kèm theo ${escapeHtml(headerInfo.attachedDocuments || "....")} chứng từ gốc).</div>

      <div class="signatures">
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Người lập bảng kê</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Kế toán trưởng</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Người duyệt</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
      </div>

      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
